





































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Login } from "@/shared/dtos/login";
import { ThemeConfig } from "@/config/theme";
import { UtilsURLS } from "@/utils/utils-urls";
import { JwtService } from "@/shared/services/JwtService";
import { UtilsBoolean } from "@/utils/utils-boolean";
import { RouterNames } from "@/router/routernames";
import UserService, {
  medicalUserService,
} from "@/shared/services/user-service";

@Component({
  $_veeValidate: { validator: "new" },
})
export default class LoginFormulario extends Vue {
  public appTitle = process.env.VUE_APP_TITLE;
  public login: Login = new Login();
  public hide: boolean = true;
  public isLoading: boolean = false;
  public theme = ThemeConfig;
  public showPasswordChangeDialog: boolean = false;
  public redirectCountdown: number = 5;
  public redirectProgress: number = 0;
  private countdownInterval: any = null;
  public showFailedAttemptsDialog: boolean = false;
  public failedAttempts: number = 0;

  get themeStyles() {
    return {
      "--primary-color": ThemeConfig.colors.primary, // #4E6566 Verde Laooal
      "--secondary-color": ThemeConfig.colors.secondary, // #6ca1da Azul-Púrpura
      "--accent-color": ThemeConfig.colors.accent, // #9A9943 Oro Laooal
      "--background-theme": ThemeConfig.colors.background,
      "--gradient-primary": ThemeConfig.gradients.primary,
      "--gradient-login-card":
        "linear-gradient(90deg, #4E6566 0%, #6E8687 100%)",
    };
  }

  get clientLogo() {
    return UtilsURLS.urls("logo_cliente.png");
  }

  public mounted() {
    this.login = new Login();

    // Cargar usuario recordado
    const savedUser = localStorage.getItem("remembered_user");
    if (savedUser) {
      this.login.UserName = savedUser;
      this.login.recordarme = true;
    }

    // Staggered animation entrance
    setTimeout(() => (this.hide = false), 100);
  }

  public async submit() {
    this.isLoading = true;
    try {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        await this.tryLogin();
      }
    } finally {
      this.isLoading = false;
    }
  }

  public async tryLogin() {
    const authorizationService = await import(
      "@/shared/services/AuthorizationService"
    );
    return authorizationService.authorizationService
      .login(this.login)
      .then(this.loginResult.bind(this));
  }

  private async loginResult(loginOk: Login) {
    if (loginOk.Success) {
      if (loginOk.doble_factor) {
        const routernames = await import("@/router/routernames");

        var parametros = {
          UserName: this.login.UserName,
          Pwd: this.login.Pwd,
          sercret_opt: loginOk.sercret_opt,
          Name: loginOk.Name,
        };
        if (loginOk.config_otp) {
          this.$router.push({
            name: routernames.RouterNames.configurarotp,
            params: parametros,
          });
        } else {
          this.$router.push({
            name: routernames.RouterNames.logearotp,
            params: parametros,
          });
        }
      } else {
        this.hide = true;
        if (loginOk.chg_pwd) {
          this.showPasswordChangeNotification();
        } else {
          // Manejar "Recordarme"
          if (this.login.recordarme) {
            localStorage.setItem("remembered_user", this.login.UserName);
          } else {
            localStorage.removeItem("remembered_user");
          }

          setTimeout(() => this.routeToMain(), 250);
        }
      }
    } else {
      if (loginOk.chg_pwd) {
        this.showPasswordChangeNotification();
      } else {
        this.failedAttempts++;
        if (this.failedAttempts >= 3) {
          this.showFailedAttemptsDialog = true;
        } else {
          const MessageService = await import(
            "@/shared/services/message-service"
          );
          MessageService.MessageService.toast(
            "Usuario o Clave incorrectos",
            MessageService.MessageService.TypeError
          );
        }
      }
    }
  }

  private routeToMain() {
    this.$router.push("/");
  }

  private async LostPwd() {
    const routernames = await import("@/router/routernames");
    this.$router.push({
      name: routernames.RouterNames.lostpwd,
      params: { email: this.login.UserName },
    });
  }

  private showPasswordChangeNotification() {
    this.showPasswordChangeDialog = true;
    this.redirectCountdown = 5;
    this.redirectProgress = 0;

    // Clear any existing interval
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    // Start countdown
    this.countdownInterval = setInterval(() => {
      this.redirectCountdown--;
      this.redirectProgress = ((5 - this.redirectCountdown) / 5) * 100;

      if (this.redirectCountdown <= 0) {
        clearInterval(this.countdownInterval);
        this.showPasswordChangeDialog = false;
        this.LostPwd();
      }
    }, 1000);
  }
  private closeFailedAttemptsDialog() {
    this.showFailedAttemptsDialog = false;
    this.failedAttempts = 0;
  }

  private goToPasswordRecovery() {
    this.showFailedAttemptsDialog = false;
    this.LostPwd();
  }

  private async goToSubscriptions() {
    this.showFailedAttemptsDialog = false;
    this.$router.push({ path: "/inicio", hash: "#tarifas" });
  }
  // Cleanup on component destroy
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}
